import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'
import inventoryServices from '@/inventory/services/services'

import { getEditInfoPayload, getItemWithSavedVariantIdentifiers, isPerVariantFieldError } from './helpers'

const useEditItemInfo = ({ storeId, refetchItems, setToastInfo }) => {
  const { t } = useTranslation()
  const [showEditItemInfoDrawer, setShowEditItemInfoDrawer] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [selectedItem, setSelectedItem] = useState(null)
  const { loading: savingChanges, fetchData: editItemInfo } = useFetch(inventoryServices.editItemInfo, {
    doInitialRequest: false,
  })
  const { data: currencies } = useFetch(commonServices.getCurrencies, {
    doInitialRequest: true,
  })
  const [applyInfoToAllVariants, setApplyInfoToAllVariants] = useState(false)

  const onOpenEditCustomsInformationDrawer = (item, product) => {
    setSelectedItem({ ...item })
    setSelectedProduct(product)
    setShowEditItemInfoDrawer(true)
    setApplyInfoToAllVariants(false)
  }

  const onCloseEditCustomsInformationDrawer = () => {
    setSelectedItem(null)
    setShowEditItemInfoDrawer(false)
  }

  const onChangeSelectedItem = item => {
    setSelectedItem(item)
  }

  const onSaveChanges = async () => {
    try {
      const payload = getEditInfoPayload({ item: selectedItem, applyInfoToAllVariants })
      await editItemInfo({ storeId, itemId: selectedItem.id, payload })
      onCloseEditCustomsInformationDrawer()
      setToastInfo({ show: true, message: t('Producto editado correctamente'), type: 'success' })
      refetchItems()
    } catch (error) {
      const message = isPerVariantFieldError(error)
        ? t('El código de barras y el NS-PID son únicos por variante y no se pueden aplicar a todas las variantes')
        : t('Error al editar un producto')

      setToastInfo({ show: true, message, type: 'error' })
    }
  }

  const onChangeApplyInfoToAllVariants = value => {
    setApplyInfoToAllVariants(value)

    if (value) setSelectedItem(getItemWithSavedVariantIdentifiers(selectedItem, selectedProduct))
  }

  return {
    showEditItemInfoDrawer,
    setShowEditItemInfoDrawer,
    selectedItem,
    setSelectedItem,
    selectedProduct,
    setSelectedProduct,
    onOpenEditCustomsInformationDrawer,
    onCloseEditCustomsInformationDrawer,
    onChangeSelectedItem,
    onSaveChanges,
    savingChanges,
    applyInfoToAllVariants,
    onChangeApplyInfoToAllVariants,
    currencies,
  }
}

export default useEditItemInfo
